<tiime-input-container tiimeFormInputContainer contentId="contract-status-select" [label]="label" [small]="small">
  <tiime-select
    id="contract-status-select"
    [customValue]="contractStatus | statusLabel: statusType"
    [placeholder]="label"
    (selectionChange)="emitSelectionChange($event)"
    data-cy="contract-status-select"
  >
    <app-status [color]="contractStatus | statusColor: statusType" tiimeSelectPrefix></app-status>
    @if (contractStatusAt) {
      <span tiimeSelectInfos>{{ '' | atBy: contractStatusAt : contractStatusBy?.acronym }}</span>
    }
    @if (contractId) {
      <app-history-infos-button
        class="show-on-hover"
        [entityType]="historyEntityType"
        [entityId]="contractId"
        [entityTitle]="historyEntityTitle"
        [statusType]="statusType"
        tiimeSelectSuffix
      ></app-history-infos-button>
    }
    <div tiimeSelectOptions>
      @for (status of selectorData; track trackByIndex($index)) {
        <mat-option
          [class.mdc-list-item--selected]="status === contractStatus"
          [value]="status"
          [disabled]="contractStatus | disableContractStatus: status"
        >
          {{ status | statusLabel: statusType }}
        </mat-option>
      }
    </div>
  </tiime-select>
</tiime-input-container>
